import { App, type URLOpenListenerEvent } from '@capacitor/app'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

const useDeeplinkListener = () => {
  const navigate = useNavigate()
  useEffect(()=> {
    const listener = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const url = new URL(event.url)
      if (url.pathname) {
        navigate(url.pathname + url.search)
      }
    })
    return ()=> {
      listener.then(l=> { l.remove() })
    }
  }, [navigate])
}

export default useDeeplinkListener